module.exports = __webpack_public_path__ + "static/media/movies.ecb4ae1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/movies.png
// module id = 34
// module chunks = 0